import React, { useState } from 'react';
import { Form, Input, Button, Card, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { login, getNetworkType } from '../api/auth';
import { useAuth } from '../utils/auth';
import './Login.css';

const Login = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login: authLogin } = useAuth();

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const networkType = getNetworkType();
      const response = await login(values.employee_id, values.password, networkType);
      
      if (response.code === 200) {
        message.success('登录成功');
        authLogin(response.data.token, response.data.user);
        
        // 统一跳转到学习页面
        navigate('/learn');
      }
    } catch (error) {
      message.error(error.message || '登录失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <Card className="login-card" title="“华工图像六项行为准则”学习平台">
        <Form
          name="login"
          onFinish={onFinish}
          autoComplete="off"
          size="large"
        >
          <Form.Item
            name="employee_id"
            rules={[{ required: true, message: '请输入工号' }]}
          >
            <Input 
              prefix={<UserOutlined />} 
              placeholder="工号" 
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: '请输入密码' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="密码"
            />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block>
              登录
            </Button>
          </Form.Item>
        </Form>
        
        <div style={{ textAlign: 'center', marginTop: '16px' }}>
          <a href="/admin/login" style={{ color: '#666' }}>
            管理员登录入口 →
          </a>
        </div>
      </Card>
    </div>
  );
};

export default Login;
